"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTimeOffAttachments = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const TIMEOFF_ATTACHMENTS_QUERY = (0, graphql_tag_1.default) `
  query TimeOffAttachments($timeOffId: ID!, $workspaceId: ID, $userId: ID) {
    timeOff(id: $timeOffId, workspace: $workspaceId, user: $userId) {
      attachments {
        fileId
        file {
          id
          filename
          size
          url
          author
          created
        }
      }
    }
  }
`;
const requestTimeOffAttachments = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(TIMEOFF_ATTACHMENTS_QUERY, {
        variables,
    });
    if ((0, util_1.isValue)(errors)) {
        return errors[0];
    }
    return data?.timeOff.attachments;
};
exports.requestTimeOffAttachments = requestTimeOffAttachments;
// async function requestTimeOffAttachments(variables, token) {
//   const response = await fetchRequest({
//     query: TIMEOFF_ATTACHMENTS_QUERY,
//     variables,
//     token,
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('', errors)
//   }
//   return data.timeOff.attachments
// }
exports.default = exports.requestTimeOffAttachments;
